(() => {
  if (window.__ReiseSidecartGiftRewardsLoaded) return;
  window.__ReiseSidecartGiftRewardsLoaded = true;

  const state = {
    pending: null,
    status: '',
    statusType: '',
    returnFocus: null,
    busy: false,
    checkoutLocked: false,
    appliedCode: null,
  };

  const giftProperties = [
    '_reise_gift',
    '_reise_gift_rule',
    '_cecilia_campaign_id',
  ];
  const requestTimeout = 6000;
  const syncTimeout = 2500;
  const operationTimeout = 20000;
  const settlementDelays = [200, 350, 600, 900, 1200, 1500];

  const couponDiagnosticEnabled = new URLSearchParams(location.search).get('reise_coupon_debug') === '1';
  let couponDiagnostic = null;

  function beginCouponDiagnostic(code) {
    if (!couponDiagnosticEnabled) return;
    const entered = String(code || '');
    couponDiagnostic = {
      version: '20261019-1',
      theme: {id: Number(window.Shopify?.theme?.id) || null},
      customerSessionKnown: window.ShopifyAnalytics?.meta?.page?.customerId ? true : null,
      path: location.pathname,
      entered_code: entered,
      codepoints: Array.from(entered, character => `U+${character.codePointAt(0).toString(16).toUpperCase().padStart(4, '0')}`),
      events: [],
    };
  }

  function recordCouponDiagnostic(event, cart, extra = {}) {
    if (!couponDiagnosticEnabled || !couponDiagnostic) return;
    const entry = {event: /^[a-z0-9_:-]{1,48}$/i.test(event) ? event : 'unknown_stage'};
    if (cart) {
      entry.cart = {
        total_price: Number.isFinite(cart.total_price) ? cart.total_price : null,
        original_total_price: Number.isFinite(cart.original_total_price) ? cart.original_total_price : null,
        items_subtotal_price: Number.isFinite(cart.items_subtotal_price) ? cart.items_subtotal_price : null,
        total_discount: Number.isFinite(cart.total_discount) ? cart.total_discount : null,
        items: (Array.isArray(cart.items) ? cart.items : []).map(item => ({
          variant_id: Number(item?.variant_id || item?.id) || null,
          quantity: Number(item?.quantity) || 0,
          price: Number(item?.price) || 0,
          original_price: Number(item?.original_price) || 0,
          final_price: Number(item?.final_price) || 0,
          final_line_price: Number(item?.final_line_price) || 0,
          discounts: (Array.isArray(item?.discounts) ? item.discounts : []).map(discount => ({
            code: String(discount?.title || ''),
            amount: Number(discount?.amount) || 0,
          })),
        })),
        cart_discount_applications: (Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []).map(discount => ({
          code: String(discount?.title || ''),
          type: String(discount?.type || ''),
          amount: Number(discount?.total_allocated_amount) || 0,
        })),
        discount_codes_present: Array.isArray(cart.discount_codes),
        discount_codes: (Array.isArray(cart.discount_codes) ? cart.discount_codes : []).map(discount => ({
          code: String(discount?.code || ''),
          applicable: typeof discount?.applicable === 'boolean' ? discount?.applicable : null,
        })),
      };
    }
    if (Number.isInteger(extra.http_status)) entry.http_status = extra.http_status;
    if (typeof extra.ok === 'boolean') entry.ok = extra.ok;
    if (typeof extra.requested_codes === 'string') entry.requested_codes = extra.requested_codes;
    if (typeof extra.notifyGiftApp === 'boolean') entry.notify_gift = extra.notifyGiftApp;
    if (typeof extra.error === 'string' && /^[a-z_]{1,64}$/.test(extra.error)) entry.error = extra.error;
    couponDiagnostic.events.push(entry);
    if (couponDiagnostic.events.length > 30) couponDiagnostic.events.shift();
  }

  function renderCouponDiagnostic(message, type) {
    if (!couponDiagnosticEnabled || !couponDiagnostic || !message) return;
    couponDiagnostic.status = {message: String(message), type: ['error', 'success'].includes(type) ? type : 'info'};
    const component = document.querySelector('#rn-cart reise-gift-coupon') || document.querySelector('reise-gift-coupon');
    if (!component) return;
    let details = component.querySelector('[data-reise-coupon-diagnostic]');
    if (!details) {
      const anchor = component.querySelector('[data-reise-coupon-status]') || component.querySelector('[data-reise-coupon-form]');
      if (!anchor) return;
      details = document.createElement('details');
      details.dataset.reiseCouponDiagnostic = '';
      details.style.cssText = 'grid-column:1/-1;min-width:0;margin-top:12px';
      const summary = document.createElement('summary');
      summary.textContent = 'Diagnóstico do cupom';
      summary.style.cssText = 'display:flex;align-items:center;min-height:44px;cursor:pointer';
      const output = document.createElement('textarea');
      output.readOnly = true;
      output.setAttribute('aria-label', 'Diagnóstico do cupom');
      output.style.cssText = 'display:block;box-sizing:border-box;width:100%;min-height:160px;resize:vertical;font:12px monospace';
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = 'Copiar diagnóstico';
      button.style.cssText = 'min-width:44px;min-height:44px;margin-top:8px;padding:8px 12px';
      button.addEventListener('click', async () => {
        try {
          if (!navigator.clipboard?.writeText) throw new Error('clipboard_unavailable');
          await navigator.clipboard.writeText(output.value);
          button.textContent = 'Diagnóstico copiado';
        } catch {
          output.focus();
          output.select();
          button.textContent = 'Texto selecionado: copie o diagnóstico';
        }
      });
      details.append(summary, output, button);
      anchor.after(details);
    }
    details.querySelector('textarea').value = JSON.stringify(couponDiagnostic, null, 2);
  }

  function createOperationDeadline() {
    return Date.now() + operationTimeout;
  }

  function timeoutWithinDeadline(deadline, maximum) {
    const remaining = Number(deadline) - Date.now();

    if (!Number.isFinite(remaining) || remaining <= 0) {
      throw new Error('operation_timeout');
    }

    return Math.max(1, Math.min(maximum, remaining));
  }

  function cartRoot() {
    const root = window.Shopify?.routes?.root || window.routes?.root || '/';

    return `${String(root).replace(/\/+$/, '')}/`;
  }

  function cartUrl(path) {
    return `${cartRoot()}${String(path).replace(/^\/+/, '')}`;
  }

  function quietFetch(...args) {
    if (
      typeof window.__reiseNativeFetch !== 'function' ||
      window.__reiseNativeFetchIsQuiet === false
    ) {
      throw new Error('native_fetch_unavailable');
    }

    return window.__reiseNativeFetch(...args);
  }

  function storedCode() {
    try {
      return localStorage.getItem('storedDiscount') || '';
    } catch (error) {
      return '';
    }
  }

  function setStoredCode(code) {
    const cleanedCode = cleanCode(code);
    state.appliedCode = cleanedCode;

    try {
      if (cleanedCode) {
        localStorage.setItem('storedDiscount', cleanedCode);
      } else {
        localStorage.removeItem('storedDiscount');
      }
    } catch (error) {
      return;
    }
  }

  function currentAppliedCode() {
    return state.appliedCode === null ? storedCode() : state.appliedCode;
  }

  function setVisibleCouponCode(code) {
    document
      .querySelectorAll(
        'reise-gift-coupon input[name="reise_offer_code"]'
      )
      .forEach((input) => {
        input.value = code || '';
        input.closest('reise-gift-coupon')?.renderActionState?.();
      });
  }

  function cleanCode(code) {
    return String(code || '').trim();
  }

  function codeKey(code) {
    return cleanCode(code).toUpperCase();
  }

  function uniqueCodes(codes) {
    const seen = new Set();

    return codes.reduce((result, code) => {
      const cleaned = cleanCode(code);
      const key = codeKey(cleaned);

      if (key && !seen.has(key)) {
        seen.add(key);
        result.push(cleaned);
      }

      return result;
    }, []);
  }

  function preferredDiscountCode(codes, preferredCode) {
    const preferredKey = codeKey(preferredCode);
    const normalizedCodes = uniqueCodes(codes);

    return (
      normalizedCodes.find((code) => codeKey(code) === preferredKey) ||
      normalizedCodes[0] ||
      ''
    );
  }

  function isManagedGift(item) {
    const properties = item?.properties || {};

    return giftProperties.some((property) => {
      if (property === '_reise_gift') return properties[property] === 'true';
      if (property === '_reise_gift_rule') {
        return properties[property] === 'cart_over_threshold';
      }
      return Boolean(properties[property]);
    });
  }

  function isThresholdGift(item) {
    return item?.properties?._reise_gift_rule === 'cart_over_threshold';
  }

  function giftIdentity(item) {
    const campaignId = cleanCode(item?.properties?._cecilia_campaign_id);
    if (campaignId) return `campaign:${campaignId}`;

    const variantId = Number(item?.variant_id || item?.id || 0);
    if (variantId) return `variant:${variantId}`;

    return item?.key ? `line:${item.key}` : '';
  }

  function campaignIdsAtThreshold(threshold) {
    try {
      const config = window.CeciliaFreeGiftCart?.readConfig?.();
      const campaigns = Array.isArray(config?.campaigns) ? config.campaigns : [];

      return new Set(
        campaigns
          .filter(
            (campaign) =>
              campaign?.enabled !== false &&
              Number(campaign?.thresholdCents) === threshold
          )
          .map((campaign) => cleanCode(campaign?.id))
          .filter(Boolean)
      );
    } catch (error) {
      return new Set();
    }
  }

  function targetGiftIdentities(cart, threshold) {
    const campaignIds = campaignIdsAtThreshold(threshold);
    const thresholdGifts = (cart?.items || []).filter(isThresholdGift);
    const matchingGifts = campaignIds.size
      ? thresholdGifts.filter((item) =>
          campaignIds.has(cleanCode(item?.properties?._cecilia_campaign_id))
        )
      : thresholdGifts;
    const scopedGifts = campaignIds.size ? matchingGifts : thresholdGifts;

    return [...new Set(scopedGifts.map(giftIdentity).filter(Boolean))];
  }

  function expectedGiftsPresent(cart, giftIds) {
    if (!giftIds.length) return true;

    const currentIds = new Set(
      (cart?.items || []).filter(isThresholdGift).map(giftIdentity)
    );

    return giftIds.every((giftId) => currentIds.has(giftId));
  }

  function targetGiftsRemoved(cart, giftIds) {
    if (!giftIds.length) return true;

    const currentIds = new Set(
      (cart?.items || []).filter(isThresholdGift).map(giftIdentity)
    );

    return giftIds.every((giftId) => !currentIds.has(giftId));
  }

  function eligibleSubtotal(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const giftTotal = items
      .filter(isManagedGift)
      .reduce(
        (total, item) =>
          total + Number(item.final_line_price ?? item.line_price ?? 0),
        0
      );
    const nonGiftSubtotal = items
      .filter((item) => !isManagedGift(item))
      .reduce(
        (total, item) =>
          total + Number(item.final_line_price ?? item.line_price ?? 0),
        0
      );
    const cartTotal = Number(cart?.total_price || 0);

    if (cartTotal > 0 || Number(cart?.total_discount || 0) > 0) {
      return Math.max(0, cartTotal - giftTotal);
    }

    return nonGiftSubtotal;
  }

  function cartDiscountCodes(cart) {
    const codes = [];
    const addCode = (code) => {
      const cleaned = cleanCode(code);
      if (cleaned) codes.push(cleaned);
    };

    if (Array.isArray(cart?.discount_codes)) {
      cart.discount_codes.forEach((discount) => {
        addCode(discount?.code);
      });
    } else if (Array.isArray(cart?.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach((discount) => {
        if (discount?.type === 'discount_code') addCode(discount?.title);
      });
    }

    return uniqueCodes(codes);
  }

  function activeDiscountCodes(cart) {
    const codes = cartDiscountCodes(cart);

    if (!Array.isArray(cart?.discount_codes) && codes.length === 0) {
      return uniqueCodes([storedCode()]);
    }

    return codes;
  }

  function cartHasDiscountCode(cart, code) {
    const normalized = codeKey(code);

    return cartDiscountCodes(cart).some(
      (discountCode) => codeKey(discountCode) === normalized
    );
  }

  function codeIsApplicable(cart, code) {
    if (!Array.isArray(cart?.discount_codes)) return false;

    const normalized = codeKey(code);
    const result = cart.discount_codes.find(
      (discount) => codeKey(discount?.code) === normalized
    );

    return result?.applicable === true;
  }

  function codesMatch(cart, expectedCodes) {
    const actual = activeDiscountCodes(cart).map(codeKey).sort();
    const expected = uniqueCodes(expectedCodes).map(codeKey).sort();

    return (
      actual.length === expected.length &&
      actual.every((code, index) => code === expected[index])
    );
  }

  function cartSignature(cart) {
    return JSON.stringify({
      total: Number(cart?.total_price || 0),
      count: Number(cart?.item_count || 0),
      codes: (cart?.discount_codes || [])
        .map((discount) => [
          codeKey(discount?.code),
          discount?.applicable !== false,
        ])
        .sort((first, second) => first[0].localeCompare(second[0])),
      items: (cart?.items || [])
        .map((item) => [
          item?.key,
          Number(item?.quantity || 0),
          Number(item?.final_line_price ?? item?.line_price ?? 0),
        ])
        .sort((first, second) =>
          String(first[0]).localeCompare(String(second[0]))
        ),
    });
  }

  function formatMoney(cents, currency) {
    if (window.Shopify?.formatMoney && window.money_format) {
      return window.Shopify.formatMoney(cents, window.money_format);
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency',
      currency: currency || 'BRL',
    }).format(Number(cents || 0) / 100);
  }

  async function fetchJsonWithTimeout(request, url, options, deadline) {
    const controller = new AbortController();
    const timeout = window.setTimeout(
      () => controller.abort(),
      timeoutWithinDeadline(deadline, requestTimeout)
    );

    try {
      const response = await request(url, {
        ...options,
        signal: controller.signal,
      });
      const data = await response.json();

      return {response, data};
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function readCart(deadline) {
    const {response, data} = await fetchJsonWithTimeout(
      quietFetch,
      cartUrl('cart.js'),
      {
        headers: {Accept: 'application/json'},
        cache: 'no-store',
      },
      deadline
    );

    recordCouponDiagnostic('read_cart', data, {http_status: response.status, ok: response.ok});
    if (!response.ok) throw new Error('cart_read_failed');
    return data;
  }

  async function updateDiscount(
    discount,
    notifyGiftApp = false,
    deadline
  ) {
    const request = notifyGiftApp ? window.fetch.bind(window) : quietFetch;
    const payload = {discount};
    if (document.getElementById('rn-cart')) {
      payload.attributes = {_reise_coupon_edited: 'true'};
    }
    const {response, data: cart} = await fetchJsonWithTimeout(
      request,
      cartUrl('cart/update.js'),
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
      deadline
    );

    recordCouponDiagnostic('update_discount', cart, {http_status: response.status, ok: response.ok, notifyGiftApp, requested_codes: discount});
    if (!response.ok || cart?.errors || cart?.status >= 400) {
      throw new Error('discount_update_failed');
    }

    return cart;
  }

  function refreshSidecart(cart, deadline) {
    if (document.getElementById('rn-cart')) {
      document.dispatchEvent(
        new CustomEvent('cart-update', {bubbles: true, detail: cart})
      );
      return Promise.resolve();
    }

    if (typeof window.sharedFunctions?.updateSidebarCart === 'function') {
      const renderTimeout = timeoutWithinDeadline(deadline, 5000);

      return new Promise((resolve, reject) => {
        let timeout;
        const expectedSignature = cartSignature(cart);
        const cleanup = () => {
          window.clearTimeout(timeout);
          document.removeEventListener('reise:sidecart-rendered', handleSuccess);
          document.removeEventListener('reise:sidecart-render-error', handleError);
        };
        const handleSuccess = (event) => {
          if (cartSignature(event.detail) !== expectedSignature) return;
          cleanup();
          resolve();
        };
        const handleError = (event) => {
          if (cartSignature(event.detail) !== expectedSignature) return;
          cleanup();
          reject(new Error('sidecart_render_failed'));
        };

        document.addEventListener('reise:sidecart-rendered', handleSuccess);
        document.addEventListener('reise:sidecart-render-error', handleError);
        timeout = window.setTimeout(
          () => {
            cleanup();
            reject(new Error('sidecart_render_timeout'));
          },
          renderTimeout
        );

        try {
          window.sharedFunctions.updateSidebarCart(cart, true);
        } catch (error) {
          cleanup();
          reject(error);
        }
      });
    }

    document.dispatchEvent(
      new CustomEvent('cart-update', {bubbles: true, detail: cart})
    );

    return Promise.resolve();
  }

  async function syncGift(deadline) {
    if (typeof window.CeciliaFreeGiftCart?.sync !== 'function') return false;

    let timeout;

    try {
      const giftSyncTimeout = timeoutWithinDeadline(deadline, syncTimeout);

      await Promise.race([
        Promise.resolve(window.CeciliaFreeGiftCart.sync()),
        new Promise((_, reject) => {
          timeout = window.setTimeout(
            () => reject(new Error('gift_sync_timeout')),
            giftSyncTimeout
          );
        }),
      ]);
      return true;
    } catch (error) {
      return false;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function wait(delay, deadline) {
    const timeout = timeoutWithinDeadline(deadline, delay);

    await new Promise((resolve) => window.setTimeout(resolve, timeout));

    if (timeout < delay) throw new Error('operation_timeout');
  }

  function cartSnapshot(cart, threshold) {
    return {
      codes: activeDiscountCodes(cart),
      giftIds: targetGiftIdentities(cart, threshold),
      threshold,
    };
  }

  async function waitForCart(predicate, errorCode, deadline) {
    await syncGift(deadline);

    let cart = await readCart(deadline);
    if (predicate(cart)) return cart;

    for (const delay of settlementDelays) {
      await wait(delay, deadline);
      cart = await readCart(deadline);

      if (predicate(cart)) return cart;
    }

    throw new Error(errorCode);
  }

  async function settleGiftRemoval(snapshot, deadline) {
    if (!snapshot.giftIds.length) return readCart(deadline);

    return waitForCart(
      (cart) =>
        eligibleSubtotal(cart) >= snapshot.threshold ||
        targetGiftsRemoved(cart, snapshot.giftIds),
      'gift_reconciliation_failed',
      deadline
    );
  }

  async function settleGiftRestoration(threshold, removedCode, deadline) {
    const expectedGiftIds = [...campaignIdsAtThreshold(threshold)].map(
      (campaignId) => `campaign:${campaignId}`
    );

    return waitForCart(
      (cart) => {
        if (cartHasDiscountCode(cart, removedCode)) return false;
        if (threshold <= 0 || eligibleSubtotal(cart) < threshold) return true;

        return (
          expectedGiftIds.length === 0 ||
          expectedGiftsPresent(cart, expectedGiftIds)
        );
      },
      'gift_restoration_failed',
      deadline
    );
  }

  async function restoreSnapshot(snapshot, quietPreferred = true, deadline) {
    const notificationModes = quietPreferred ? [false, true] : [true, true];
    let lastError;

    for (const notifyGiftApp of notificationModes) {
      try {
        const restoredCart = await updateDiscount(
          snapshot.codes.join(','),
          notifyGiftApp,
          deadline
        );

        if (!codesMatch(restoredCart, snapshot.codes)) {
          throw new Error('discount_restore_failed');
        }

        if (!snapshot.giftIds.length) {
          return restoredCart;
        }

        await syncGift(deadline);
        await wait(300, deadline);
        const verifiedCart = await readCart(deadline);

        if (
          codesMatch(verifiedCart, snapshot.codes) &&
          expectedGiftsPresent(verifiedCart, snapshot.giftIds)
        ) {
          return verifiedCart;
        }

        return await waitForCart(
          (cart) =>
            codesMatch(cart, snapshot.codes) &&
            expectedGiftsPresent(cart, snapshot.giftIds),
          'cart_restore_failed',
          deadline
        );
      } catch (error) {
        lastError = error;
      }
    }

    throw lastError || new Error('cart_restore_failed');
  }

  function setCheckoutBusy(isBusy) {
    const checkout =
      document.querySelector('#rn-cart [name="checkout"]') ||
      document.getElementById('cart-sidebar-checkout');
    if (!checkout) return;

    if (isBusy) {
      if (!checkout.hasAttribute('data-reise-was-disabled')) {
        checkout.dataset.reiseWasDisabled = String(checkout.disabled);
      }
      checkout.disabled = true;
      checkout.setAttribute('aria-busy', 'true');
      return;
    }

    if (checkout.dataset.reiseWasDisabled === 'false') checkout.disabled = false;
    checkout.removeAttribute('aria-busy');
    delete checkout.dataset.reiseWasDisabled;
  }

  function applyCheckoutLockToCurrentButton() {
    const checkout =
      document.querySelector('#rn-cart [name="checkout"]') ||
      document.getElementById('cart-sidebar-checkout');
    if (!checkout) return;

    if (!checkout.hasAttribute('data-reise-was-disabled')) {
      checkout.dataset.reiseWasDisabled = String(checkout.disabled);
    }

    checkout.disabled = true;
    checkout.removeAttribute('aria-busy');
  }

  function setSidecartBusy(isBusy) {
    state.busy = isBusy;

    const wrapper =
      document.querySelector('#rn-cart [data-rn-cart-items]') ||
      document.querySelector('#halo-cart-sidebar .previewCart-wrapper');

    if (wrapper) {
      wrapper.inert = isBusy;
      wrapper.toggleAttribute('aria-busy', isBusy);
    }

    if (isBusy) {
      setCheckoutBusy(true);
    } else if (state.checkoutLocked) {
      applyCheckoutLockToCurrentButton();
    } else {
      setCheckoutBusy(false);
    }

    emitCouponStatus();
  }

  function renderStatus() {
    document.querySelectorAll('reise-gift-coupon').forEach((component) => {
      component.renderStatus?.();
    });
  }

  function setStatus(message, type = '') {
    state.status = message;
    state.statusType = type;
    renderCouponDiagnostic(message, type);
    renderStatus();
    emitCouponStatus();
  }

  function emitCouponStatus() {
    document.dispatchEvent(
      new CustomEvent('reise:coupon-status', {
        detail: {
          message: state.status,
          type: state.statusType,
          code: currentAppliedCode(),
          busy: state.busy,
          checkoutLocked: state.checkoutLocked,
        },
      })
    );
  }

  function dialogElement() {
    return document.querySelector('[data-reise-gift-warning-dialog]');
  }

  let dialogPositionFrame = 0;

  function resetGiftWarningPosition(dialog = dialogElement()) {
    if (!dialog) return;

    dialog.classList.remove('is-anchored');
    dialog.style.removeProperty('--reise-gift-dialog-left');
    dialog.style.removeProperty('--reise-gift-dialog-top');
    dialog.style.removeProperty('--reise-gift-dialog-width');
    dialog.style.removeProperty('--reise-gift-dialog-max-height');
  }

  function positionGiftWarning() {
    const dialog = dialogElement();
    const anchor =
      document.querySelector('#rn-cart reise-gift-coupon') ||
      document.querySelector('#halo-cart-sidebar reise-gift-coupon');

    if (!dialog?.open || !anchor) return;

    const anchorRect = anchor.getBoundingClientRect();
    if (anchorRect.width <= 0) return;

    const viewportPadding = 12;
    const anchorGap = 10;
    const width = Math.min(
      anchorRect.width,
      window.innerWidth - viewportPadding * 2
    );
    const availableHeight = Math.max(
      96,
      anchorRect.top - anchorGap - viewportPadding
    );

    dialog.style.setProperty(
      '--reise-gift-dialog-width',
      `${Math.round(width)}px`
    );
    dialog.style.setProperty(
      '--reise-gift-dialog-max-height',
      `${Math.round(availableHeight)}px`
    );

    const dialogHeight = dialog.getBoundingClientRect().height;
    const left = Math.min(
      Math.max(anchorRect.left, viewportPadding),
      window.innerWidth - width - viewportPadding
    );
    const top = Math.max(
      viewportPadding,
      anchorRect.top - dialogHeight - anchorGap
    );

    dialog.style.setProperty(
      '--reise-gift-dialog-left',
      `${Math.round(left)}px`
    );
    dialog.style.setProperty(
      '--reise-gift-dialog-top',
      `${Math.round(top)}px`
    );
    dialog.classList.add('is-anchored');
  }

  function queueGiftWarningPosition() {
    window.cancelAnimationFrame(dialogPositionFrame);
    dialogPositionFrame = window.requestAnimationFrame(() => {
      dialogPositionFrame = 0;
      positionGiftWarning();
    });
  }

  function setDialogBusy(isBusy) {
    const dialog = dialogElement();
    if (!dialog) return;

    dialog.toggleAttribute('aria-busy', isBusy);
    dialog.querySelectorAll('button').forEach((button) => {
      const isRecoveryApply =
        button.hasAttribute('data-reise-apply-coupon') &&
        state.pending?.recoveryOnly;

      button.disabled = isBusy || isRecoveryApply;
    });
  }

  function closeDialog(focusTarget = state.returnFocus) {
    const dialog = dialogElement();
    if (dialog?.open) dialog.close();

    state.returnFocus = null;
    window.setTimeout(() => {
      if (focusTarget?.isConnected) {
        focusTarget.focus();
        return;
      }

      document
        .querySelector('reise-gift-coupon input[name="reise_offer_code"]')
        ?.focus();
    }, 0);
  }

  function openGiftWarning(pending) {
    const dialog = dialogElement();
    if (!dialog) return;

    const title = dialog.querySelector('[data-reise-gift-warning-title]');
    const message = dialog.querySelector('[data-reise-gift-warning-message]');
    const error = dialog.querySelector('[data-reise-gift-warning-error]');
    const applyButton = dialog.querySelector('[data-reise-apply-coupon]');
    const template = dialog.dataset.messageTemplate || '';

    if (title) {
      title.textContent = pending.recoveryOnly
        ? dialog.dataset.recoveryTitle
        : dialog.dataset.warningTitle;
    }

    if (message) {
      if (pending.recoveryOnly) {
        message.textContent = pending.recoveryMessage;
      } else {
        const missing = formatMoney(pending.missing, pending.currency);
        const target = formatMoney(pending.threshold, pending.currency);

        message.textContent = template
          .replace('__AMOUNT__', missing)
          .replace('__TARGET__', target);
      }
    }
    if (error) {
      error.textContent = '';
      error.hidden = true;
    }
    if (applyButton) applyButton.disabled = Boolean(pending.recoveryOnly);

    if (!dialog.open) dialog.showModal();
    positionGiftWarning();
    dialog.querySelector('[data-reise-keep-gift]')?.focus();
  }

  function showDialogError(message) {
    const dialog = dialogElement();
    const error = dialog?.querySelector('[data-reise-gift-warning-error]');
    if (!dialog || !error) return;

    error.textContent = message || dialog.dataset.errorMessage || '';
    error.hidden = false;
    queueGiftWarningPosition();
  }

  async function confirmCoupon() {
    const pending = state.pending;
    if (!pending || pending.recoveryOnly || state.busy) return;
    const deadline = createOperationDeadline();

    setDialogBusy(true);
    setSidecartBusy(true);

    let mutationAttempted = false;

    try {
      mutationAttempted = true;
      const discountedCart = await updateDiscount(
        pending.discountString,
        true,
        deadline
      );
      if (!codeIsApplicable(discountedCart, pending.code)) {
        throw new Error('coupon_rejected');
      }

      const cart = await settleGiftRemoval(pending.snapshot, deadline);
      if (!codeIsApplicable(cart, pending.code)) {
        throw new Error('coupon_rejected_after_sync');
      }

      setStoredCode(pending.code);
      await refreshSidecart(cart, deadline);
      setStatus(pending.appliedMessage, 'success');
      state.pending = null;
      state.checkoutLocked = false;
      closeDialog(
        document.querySelector('#halo-cart-sidebar [data-close-cart-sidebar]')
      );
    } catch (error) {
      let rollbackVerified = !mutationAttempted;

      if (mutationAttempted) {
        try {
          const restoredCart = await restoreSnapshot(
            pending.snapshot,
            false,
            deadline
          );
          rollbackVerified = true;
          setStoredCode(pending.snapshot.codes[0] || '');
          try {
            await refreshSidecart(restoredCart, deadline);
          } catch (renderError) {
            setStatus(pending.errorMessage, 'error');
          }
        } catch (restoreError) {
          rollbackVerified = false;
        }
      }

      pending.rollbackVerified = rollbackVerified;
      pending.recoveryOnly = !rollbackVerified;
      state.checkoutLocked = !rollbackVerified;

      if (rollbackVerified) {
        setStoredCode(pending.snapshot.codes[0] || '');
      }

      if (rollbackVerified) showDialogError(pending.errorMessage);
      else openGiftWarning(pending);
    } finally {
      setDialogBusy(false);
      setSidecartBusy(false);
    }
  }

  async function keepGift() {
    const pending = state.pending;
    if (!pending || state.busy) return;
    const deadline = createOperationDeadline();

    setDialogBusy(true);
    setSidecartBusy(true);

    try {
      const restoredCart = await restoreSnapshot(
        pending.snapshot,
        false,
        deadline
      );
      const restoredCode = preferredDiscountCode(
        pending.snapshot.codes,
        pending.displayCode
      );
      state.pending = null;
      state.checkoutLocked = false;
      setStoredCode(restoredCode);
      setVisibleCouponCode(restoredCode);

      try {
        await refreshSidecart(restoredCart, deadline);
        setVisibleCouponCode(restoredCode);
        setStatus(pending.keptMessage, 'success');
      } catch (renderError) {
        setStatus(pending.errorMessage, 'error');
      }

      closeDialog();
    } catch (error) {
      pending.rollbackVerified = false;
      pending.recoveryOnly = true;
      state.checkoutLocked = true;
      openGiftWarning(pending);
    } finally {
      setDialogBusy(false);
      setSidecartBusy(false);
    }
  }

  function initDialog() {
    const dialog = dialogElement();
    if (!dialog || dialog.dataset.reiseReady === 'true') return;

    dialog.dataset.reiseReady = 'true';
    dialog
      .querySelector('[data-reise-apply-coupon]')
      ?.addEventListener('click', confirmCoupon);
    dialog
      .querySelector('[data-reise-keep-gift]')
      ?.addEventListener('click', keepGift);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      keepGift();
    });
    dialog.addEventListener('close', () => {
      window.cancelAnimationFrame(dialogPositionFrame);
      dialogPositionFrame = 0;
      resetGiftWarningPosition(dialog);
    });
    window.addEventListener('resize', queueGiftWarningPosition);
    window.addEventListener('scroll', queueGiftWarningPosition, {
      capture: true,
      passive: true,
    });
  }

  class ReiseGiftCoupon extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-reise-coupon-form]');
      this.input = this.querySelector('input[name="reise_offer_code"]');
      this.submitButton = this.querySelector('[data-reise-coupon-submit]');

      if (!this.form || !this.input || !this.submitButton) return;

      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleInput = this.handleInput.bind(this);
      this.form.addEventListener('submit', this.handleSubmit);
      this.input.addEventListener('input', this.handleInput);

      const code = state.pending?.code || currentAppliedCode();
      if (code && !this.input.value) this.input.value = code;
      this.renderActionState();
      this.renderStatus();

      if (state.busy) setCheckoutBusy(true);
      else if (state.checkoutLocked) applyCheckoutLockToCurrentButton();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
      this.input?.removeEventListener('input', this.handleInput);
    }

    handleInput() {
      this.renderActionState();

      if (state.status) setStatus('', '');
    }

    isRemoveAction(code = this.input?.value) {
      const appliedCode = currentAppliedCode();

      return Boolean(
        appliedCode && codeKey(code) === codeKey(appliedCode)
      );
    }

    renderActionState() {
      if (!this.submitButton) return;

      const isRemove = this.isRemoveAction();
      this.submitButton.dataset.action = isRemove ? 'remove' : 'apply';
      this.submitButton.classList.toggle('is-remove', isRemove);
      this.submitButton.textContent = isRemove
        ? this.dataset.removeLabel
        : this.dataset.applyLabel;
    }

    setBusy(isBusy) {
      const isRemoving = this.isRemoveAction();
      this.toggleAttribute('aria-busy', isBusy);
      this.input.disabled = isBusy;
      this.submitButton.disabled = isBusy;

      if (isBusy) {
        this.submitButton.textContent = isRemoving
          ? this.dataset.removingMessage
          : this.dataset.checkingMessage;
      } else {
        this.renderActionState();
      }
    }

    renderStatus() {
      const status = this.querySelector('[data-reise-coupon-status]');
      if (!status) return;

      status.textContent = state.status;
      status.hidden = !state.status;
      status.classList.toggle('is-error', state.statusType === 'error');
      this.input?.setAttribute(
        'aria-invalid',
        state.statusType === 'error' ? 'true' : 'false'
      );
    }

    async removeCoupon(code) {
      this.setBusy(true);
      setSidecartBusy(true);
      setStatus('', '');

      let snapshot = null;
      let mutationAttempted = false;
      let focusInputAfterBusy = false;
      let threshold = 0;
      let currency = 'BRL';
      const checkoutWasLocked = state.checkoutLocked;
      const deadline = createOperationDeadline();

      try {
        const beforeCart = await readCart(deadline);
        const beforeCodes = cartDiscountCodes(beforeCart);
        const hasCode = beforeCodes.some(
          (discountCode) => codeKey(discountCode) === codeKey(code)
        );
        const remainingCodes = beforeCodes.filter(
          (discountCode) => codeKey(discountCode) !== codeKey(code)
        );

        threshold = Number(this.dataset.giftThreshold) || 0;
        currency = beforeCart.currency || currency;
        snapshot = cartSnapshot(beforeCart, threshold);

        if (!hasCode) {
          const nextCode = preferredDiscountCode(remainingCodes, '');
          setStoredCode(nextCode);
          setVisibleCouponCode(nextCode);
          setStatus(this.dataset.removedMessage, 'success');
          state.checkoutLocked = false;
          focusInputAfterBusy = true;
          return;
        }

        mutationAttempted = true;
        const updatedCart = await updateDiscount(
          remainingCodes.join(','),
          true,
          deadline
        );

        if (cartHasDiscountCode(updatedCart, code)) {
          throw new Error('coupon_remove_failed');
        }

        let settledCart = updatedCart;

        try {
          settledCart = await settleGiftRestoration(
            threshold,
            code,
            deadline
          );
        } catch (giftError) {
          settledCart = updatedCart;
        }

        if (cartHasDiscountCode(settledCart, code)) {
          throw new Error('coupon_remove_failed_after_sync');
        }

        const nextCode = preferredDiscountCode(remainingCodes, '');
        setStoredCode(nextCode);
        await refreshSidecart(settledCart, deadline);
        setVisibleCouponCode(nextCode);
        setStatus(this.dataset.removedMessage, 'success');
        state.checkoutLocked = false;
        focusInputAfterBusy = true;
      } catch (error) {
        let rollbackVerified = !mutationAttempted && !checkoutWasLocked;

        if (snapshot && mutationAttempted) {
          try {
            const restoredCart = await restoreSnapshot(
              snapshot,
              false,
              deadline
            );
            const restoredCode = preferredDiscountCode(snapshot.codes, code);
            rollbackVerified = true;
            setStoredCode(restoredCode);
            setVisibleCouponCode(restoredCode);

            try {
              await refreshSidecart(restoredCart, deadline);
              setVisibleCouponCode(restoredCode);
            } catch (renderError) {
              setStatus(this.dataset.removeErrorMessage, 'error');
            }
          } catch (restoreError) {
            rollbackVerified = false;
          }
        }

        state.checkoutLocked = !rollbackVerified;

        if (!rollbackVerified && snapshot) {
          state.returnFocus = this.submitButton;
          state.pending = {
            code,
            displayCode: code,
            discountString: snapshot.codes.join(','),
            snapshot,
            threshold,
            missing: 0,
            currency,
            appliedMessage: this.dataset.appliedMessage,
            errorMessage: this.dataset.removeErrorMessage,
            recoveryMessage: this.dataset.recoveryMessage,
            keptMessage: this.dataset.removeRestoredMessage,
            rollbackVerified: false,
            recoveryOnly: true,
          };
          openGiftWarning(state.pending);
        }

        setStatus(
          rollbackVerified
            ? this.dataset.removeErrorMessage
            : this.dataset.recoveryMessage,
          'error'
        );
      } finally {
        this.setBusy(false);
        setSidecartBusy(false);

        if (focusInputAfterBusy) {
          window.setTimeout(() => {
            document
              .querySelector(
                'reise-gift-coupon input[name="reise_offer_code"]'
              )
              ?.focus();
          }, 0);
        }
      }
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (state.busy) return;

      if (state.pending) {
        openGiftWarning(state.pending);
        return;
      }

      const code = cleanCode(this.input.value);
      beginCouponDiagnostic(this.input.value);
      if (!code) {
        setStatus(this.dataset.requiredMessage, 'error');
        this.input.focus();
        return;
      }

      if (this.isRemoveAction(code)) {
        await this.removeCoupon(code);
        return;
      }

      this.setBusy(true);
      setSidecartBusy(true);
      setStatus('', '');

      let snapshot = null;
      let previewMutationAttempted = false;
      let commitMutationAttempted = false;
      let failureMessage = this.dataset.errorMessage;
      let focusInputAfterBusy = false;
      let recoveryDiscountString = code;
      let recoveryThreshold = 0;
      let recoveryCurrency = 'BRL';
      const checkoutWasLocked = state.checkoutLocked;
      const deadline = createOperationDeadline();

      try {
        const beforeCart = await readCart(deadline);
        const threshold = Number(this.dataset.giftThreshold) || 0;
        const beforeSubtotal = eligibleSubtotal(beforeCart);
        snapshot = cartSnapshot(beforeCart, threshold);
        const discountString = uniqueCodes([...snapshot.codes, code]).join(',');
        recoveryDiscountString = discountString;
        recoveryThreshold = threshold;
        recoveryCurrency = beforeCart.currency || recoveryCurrency;

        previewMutationAttempted = true;
        const discountedCart = await updateDiscount(
          discountString,
          false,
          deadline
        );

        if (!codeIsApplicable(discountedCart, code)) {
          await restoreSnapshot(snapshot, true, deadline);
          previewMutationAttempted = false;
          state.checkoutLocked = false;
          setStatus(this.dataset.invalidMessage, 'error');
          return;
        }

        const discountedSubtotal = eligibleSubtotal(discountedCart);
        const losesGift =
          threshold > 0 &&
          beforeSubtotal >= threshold &&
          discountedSubtotal < threshold;

        if (losesGift) {
          await restoreSnapshot(snapshot, true, deadline);
          previewMutationAttempted = false;
          state.checkoutLocked = false;
          state.returnFocus = this.submitButton;
          state.pending = {
            code,
            discountString,
            snapshot,
            threshold,
            missing: threshold - discountedSubtotal,
            currency: discountedCart.currency || beforeCart.currency,
            appliedMessage: this.dataset.appliedMessage,
            errorMessage: this.dataset.errorMessage,
            recoveryMessage: this.dataset.recoveryMessage,
            keptMessage: this.dataset.keptMessage,
            rollbackVerified: true,
          };
          openGiftWarning(state.pending);
          return;
        }

        await restoreSnapshot(snapshot, true, deadline);
        previewMutationAttempted = false;

        commitMutationAttempted = true;
        const committedCart = await updateDiscount(
          discountString,
          true,
          deadline
        );

        if (!codeIsApplicable(committedCart, code)) {
          failureMessage = this.dataset.invalidMessage;
          throw new Error('coupon_rejected');
        }

        await syncGift(deadline);
        const settledCart = await readCart(deadline);
        if (!codeIsApplicable(settledCart, code)) {
          failureMessage = this.dataset.invalidMessage;
          throw new Error('coupon_rejected_after_sync');
        }

        setStoredCode(code);
        await refreshSidecart(settledCart, deadline);
        setVisibleCouponCode(code);
        setStatus(this.dataset.appliedMessage, 'success');
        state.checkoutLocked = false;
        focusInputAfterBusy = true;
      } catch (error) {
        recordCouponDiagnostic('operation_error', null, {error: error.message});
        const mutationAttempted =
          previewMutationAttempted || commitMutationAttempted;
        let rollbackVerified = !mutationAttempted && !checkoutWasLocked;

        if (snapshot && mutationAttempted) {
          try {
            const restoredCart = await restoreSnapshot(
              snapshot,
              !commitMutationAttempted,
              deadline
            );
            rollbackVerified = true;
            setStoredCode(snapshot.codes[0] || '');
            setVisibleCouponCode(snapshot.codes[0] || '');
            try {
              await refreshSidecart(restoredCart, deadline);
              setVisibleCouponCode(snapshot.codes[0] || '');
            } catch (renderError) {
              setStatus(failureMessage, 'error');
            }
          } catch (restoreError) {
            rollbackVerified = false;
          }
        }

        state.checkoutLocked = !rollbackVerified;

        if (rollbackVerified && snapshot) {
          setStoredCode(snapshot.codes[0] || '');
        }

        if (!rollbackVerified && snapshot) {
          state.returnFocus = this.submitButton;
          state.pending = {
            code,
            discountString: recoveryDiscountString,
            snapshot,
            threshold: recoveryThreshold,
            missing: 0,
            currency: recoveryCurrency,
            appliedMessage: this.dataset.appliedMessage,
            errorMessage: this.dataset.errorMessage,
            recoveryMessage: this.dataset.recoveryMessage,
            keptMessage: this.dataset.keptMessage,
            rollbackVerified: false,
            recoveryOnly: true,
          };
          openGiftWarning(state.pending);
        }

        setStatus(
          rollbackVerified ? failureMessage : this.dataset.recoveryMessage,
          'error'
        );
      } finally {
        this.setBusy(false);
        setSidecartBusy(false);

        if (focusInputAfterBusy) {
          window.setTimeout(() => {
            document
              .querySelector(
                'reise-gift-coupon input[name="reise_offer_code"]'
              )
              ?.focus();
          }, 0);
        }
      }
    }
  }

  if (!customElements.get('reise-gift-coupon')) {
    customElements.define('reise-gift-coupon', ReiseGiftCoupon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDialog, {once: true});
  } else {
    initDialog();
  }
})();
